import yup, {
    integerPositiveValidator,
    integerNegativeAllowedValidator,
    imageValidator,
    arrayValidator,
    cardNameValidator,
    ckEditorValidator,
} from '~/utils/validators.yup';
import { MAX_DESCRIPTION } from '~/config/constants';
import { statusDetailRule } from '../components/form-sections/StatusDetail/statusDetailRule';
import { cardTransformedDetailRule } from '../components/form-sections/CardTransformedDetail/cardTransformedDetailRule';
import { dvComparedDetailRule } from '../components/form-sections/DvComparedDetail/dvComparedDetailRule';
import { typeDetailRule } from '../components/form-sections/TypeDetail/typeDetailRule';
import { rewardPenaltyDetailRule } from '../components/form-sections/RewardPenaltyDetail/rewardPenaltyDetailRule';
import { conditionCheckDetailRule } from '../components/form-sections/ConditionCheckDetail/conditionCheckDetailRule';
import { conditionSuccessFailureDetailRule } from '../components/form-sections/ConditionSuccessFailureDetail/conditionSuccessFailureDetailRule';
import { conditionAfterDetailRule } from '../components/form-sections/ConditionAfterDetail/conditionAfterDetailRule';
import { conditionPassiveDetailRule } from '../components/form-sections/ConditionPassiveDetail/conditionPassiveDetailRule';
import { promptDetailRule } from '../components/form-sections/PromptDetail/promptDetailRule';
import { restrictionDetailRule } from '../components/form-sections/RestrictionDetail/restrictionDetailRule';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: ckEditorValidator(MAX_DESCRIPTION),
        cardFrame: imageValidator(nullable),
        cardArt: imageValidator(nullable),
        icon: imageValidator(nullable),
        template: yup.object().shape({
            cardBack: imageValidator(true),
        }),
        keywords: arrayValidator,
        basicDetail: yup.object().shape({
            startEffects: arrayValidator,
            modifiedDv1Value: integerNegativeAllowedValidator,
            modifiedDv2Value: integerNegativeAllowedValidator,
            attackModifiedValue: integerNegativeAllowedValidator,
            defenseModifiedValue: integerNegativeAllowedValidator,
            fixedDvValue: integerPositiveValidator.required(),
            maxDvValue: integerPositiveValidator.required(),
            damageValue: integerPositiveValidator,
            healedValue: integerPositiveValidator,
            hpValue: integerPositiveValidator,
            blockModifiedValue: integerPositiveValidator,
            duelEffects: arrayValidator,
            numberOfCardsToMoveValue: integerPositiveValidator,
            hitValue: integerPositiveValidator,
            penaltyDvValue: integerPositiveValidator,
            pointToStealValue: integerPositiveValidator,
            powerToRefresh: yup.mixed(),
            persistentDvValue: integerPositiveValidator,
            persistentStrikeValue: integerPositiveValidator,
            persistentBlockValue: integerPositiveValidator,
            opponentPersistentDvValue: integerPositiveValidator,
            opponentPersistentStrikeValue: integerPositiveValidator,
            opponentPersistentBlockValue: integerPositiveValidator,
        }),
        ...statusDetailRule,
        ...cardTransformedDetailRule,
        ...dvComparedDetailRule,
        ...typeDetailRule,
        ...rewardPenaltyDetailRule,
        ...conditionCheckDetailRule,
        ...conditionSuccessFailureDetailRule,
        ...conditionAfterDetailRule,
        ...conditionPassiveDetailRule,
        ...promptDetailRule,
        ...restrictionDetailRule,
    });
